import globals from '@descope-ui/theme-globals';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { TimerButtonClass } from './component/TimerButtonClass';

const globalRefs = getThemeRefs(globals);
const vars = TimerButtonClass.cssVarList;

const timerButton = {
  [vars.gap]: globalRefs.spacing.sm,
  [vars.flexDirection]: 'column',

  _horizontal: {
    [vars.flexDirection]: 'row',
  },

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default timerButton;

export { vars };
